
import AllRoutes from './AllRoutes/AllRoutes';
import './App.css';
import { Box } from '@mui/material';

function App() {
  return (
    <Box sx={{
      "& .MuiContainer-root":{
        "@media (min-width:1260px)":{
          maxWidth:"1500px"
        },
      }
      
    }}>
    <AllRoutes/>
    </Box>
  );
}

export default App;
